/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDynamicFieldContext } from "./use-dynamic-field-context";

export function useDynamicFieldPosition () {
    const context = useDynamicFieldContext();
    return context.position;
}
